"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
require("./Bar.scss");
function BarDivider(props) {
    var vertical = false;
    var horizontal = false;
    if (props.orientation === 'vertical') {
        vertical = true;
    }
    else {
        horizontal = true;
    }
    var barClasses = classNames({
        'vertical-divider': vertical,
        'divider': horizontal
    });
    return (React.createElement("li", { role: 'separator', className: barClasses }));
}
exports.BarDivider = BarDivider;
//# sourceMappingURL=BarDivider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@abb/common-ux/dist/components/Bar/BarDivider.js
// module id = 571
// module chunks = 1